<template>
    <div id="all">
        <main id="main" class="has-nav">
            <div class="container">
                <div class="title-wrapper">
                    <h1 class="title line">Customers</h1>
                    <div class="buttons-box">
                        <a href="#" class="btn success" @click.prevent="addNewCustomer">
                            <icon-base width="20" height="21" viewBox="0 0 20 21"><icon-plus color="white"/></icon-base>
                            <span>Add new</span>
                        </a>
                    </div>
                </div>

                <div class="sort-wrapper">
                    <sort-box @sortClick="openSort = !openSort" :param="names[filterParam]" :open="openSort"/>
                    <div class="mobile-filter-box">
                            <span class="mobile-filter-btn" @click.prevent="mobileFilterClick">
                                <icon-base width="15" height="15" viewBox="0 0 15 15" ><icon-filter-mobile/></icon-base>
                                <span>Filter</span>
                            </span>
                    </div>
                </div>

                <div class="filter-result-items">
                    <div class="item">
                        <div class="item-icon-close">
                            <svg width="12" height="13" viewBox="0 0 12 13" fill="none"
                                 xmlns="http://www.w3.org/2000/svg">
                                <path fill-rule="evenodd" clip-rule="evenodd"
                                      d="M11.2075 12.5L0 1.29249L0.79249 0.5L12 11.7075L11.2075 12.5Z" fill="white"/>
                                <path fill-rule="evenodd" clip-rule="evenodd"
                                      d="M4.63779e-07 11.7075L11.2075 0.5L12 1.29249L0.792492 12.5L4.63779e-07 11.7075Z"
                                      fill="white"/>
                            </svg>
                        </div>
                        <div class="item-box">
                            <p class="item-title">Company:</p>
                            <div class="item-result">France Televisions</div>
                        </div>
                    </div>
                    <div class="item">
                        <div class="item-icon-close">
                            <svg width="12" height="13" viewBox="0 0 12 13" fill="none"
                                 xmlns="http://www.w3.org/2000/svg">
                                <path fill-rule="evenodd" clip-rule="evenodd"
                                      d="M11.2075 12.5L0 1.29249L0.79249 0.5L12 11.7075L11.2075 12.5Z" fill="white"/>
                                <path fill-rule="evenodd" clip-rule="evenodd"
                                      d="M4.63779e-07 11.7075L11.2075 0.5L12 1.29249L0.792492 12.5L4.63779e-07 11.7075Z"
                                      fill="white"/>
                            </svg>
                        </div>
                        <div class="item-box">
                            <p class="item-title">Contact person:</p>
                            <p class="item-result">Albert Flores</p>
                        </div>
                    </div>
                    <div class="item">
                        <div class="item-icon-close">
                            <svg width="12" height="13" viewBox="0 0 12 13" fill="none"
                                 xmlns="http://www.w3.org/2000/svg">
                                <path fill-rule="evenodd" clip-rule="evenodd"
                                      d="M11.2075 12.5L0 1.29249L0.79249 0.5L12 11.7075L11.2075 12.5Z" fill="white"/>
                                <path fill-rule="evenodd" clip-rule="evenodd"
                                      d="M4.63779e-07 11.7075L11.2075 0.5L12 1.29249L0.792492 12.5L4.63779e-07 11.7075Z"
                                      fill="white"/>
                            </svg>
                        </div>
                        <div class="item-box">
                            <p class="item-title">Email:</p>
                            <p class="item-result">albert.flores@francetv.com</p>
                        </div>
                    </div>
                    <div class="item">
                        <div class="item-icon-close">
                            <svg width="12" height="13" viewBox="0 0 12 13" fill="none"
                                 xmlns="http://www.w3.org/2000/svg">
                                <path fill-rule="evenodd" clip-rule="evenodd"
                                      d="M11.2075 12.5L0 1.29249L0.79249 0.5L12 11.7075L11.2075 12.5Z" fill="white"/>
                                <path fill-rule="evenodd" clip-rule="evenodd"
                                      d="M4.63779e-07 11.7075L11.2075 0.5L12 1.29249L0.792492 12.5L4.63779e-07 11.7075Z"
                                      fill="white"/>
                            </svg>
                        </div>
                        <div class="item-box">
                            <p class="item-title">Phone number:</p>
                            <p class="item-result">+331234567890</p>
                        </div>
                    </div>
                    <div class="item">
                        <div class="item-icon-close">
                            <svg width="12" height="13" viewBox="0 0 12 13" fill="none"
                                 xmlns="http://www.w3.org/2000/svg">
                                <path fill-rule="evenodd" clip-rule="evenodd"
                                      d="M11.2075 12.5L0 1.29249L0.79249 0.5L12 11.7075L11.2075 12.5Z" fill="white"/>
                                <path fill-rule="evenodd" clip-rule="evenodd"
                                      d="M4.63779e-07 11.7075L11.2075 0.5L12 1.29249L0.792492 12.5L4.63779e-07 11.7075Z"
                                      fill="white"/>
                            </svg>
                        </div>
                        <div class="item-box">
                            <p class="item-title">Billing CC:</p>
                            <p class="item-result">CC65432</p>
                        </div>
                    </div>
                    <div class="item">
                        <div class="item-icon-close">
                            <svg width="12" height="13" viewBox="0 0 12 13" fill="none"
                                 xmlns="http://www.w3.org/2000/svg">
                                <path fill-rule="evenodd" clip-rule="evenodd"
                                      d="M11.2075 12.5L0 1.29249L0.79249 0.5L12 11.7075L11.2075 12.5Z" fill="white"/>
                                <path fill-rule="evenodd" clip-rule="evenodd"
                                      d="M4.63779e-07 11.7075L11.2075 0.5L12 1.29249L0.792492 12.5L4.63779e-07 11.7075Z"
                                      fill="white"/>
                            </svg>
                        </div>
                        <div class="item-box">
                            <p class="item-title">Date of creation:</p>
                            <div class="item-result">
                                <div class="date-time-block">
                                    <span class="date">09.01.2020</span>
                                    <span class="time">10:00 pm</span>
                                </div>
                                <div class="date-time-block">
                                    <span class="date">09.10.2020</span>
                                    <span class="time">12:00 am</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>


                <div class="table-box">
                    <div class="table customers-table">
                        <div class="table-head" :style="openSort ? 'display: flex;': ''">
                            <simple-table-filter name="company" label="Company" @filter="filterClick" :param="filterParam" class="company-name-col"/>
                            <simple-table-filter name="contact_person" label="Contact person" @filter="filterClick" :param="filterParam" class="person-col"/>
                            <simple-table-filter name="email" label="Email" @filter="filterClick" :param="filterParam" class="email-col" :filter="true"/>
                            <simple-table-filter name="phone_number" label="Phone number" @filter="filterClick" :param="filterParam" class="phone-col" :filter="true"/>
                            <simple-table-filter name="billing_cc" label="Billing CC" @filter="filterClick" :param="filterParam" class="billing-col" :filter="true"/>
                            <simple-table-filter name="created_at" label="Created" @filter="filterClick" :param="filterParam" class="creaded-col"/>
                            <div class="col btn-col"></div>

                        </div>

                        <div class="table-body" :class="loading ? 'loading' : ''">
                            <div v-for="(customer, index) in customers" v-bind:key="index" class="row">
                                <div class="col company-name-col"><p>{{customer.company}}</p></div>
                                <div class="col person-col"><p>{{customer.contact_person}}</p></div>
                                <div class="col email-col">
                                    <div class="col-wrap email">
                                        <icon-base width="20" height="21" viewBox="0 0 20 21"><icon-mail/></icon-base>
                                        <a :href="'mailto:'+customer.email">{{customer.email}}</a></div>
                                </div>
                                <div class="col phone-col">
                                    <div class="col-wrap">
                                        <icon-base width="20" height="21" viewBox="0 0 20 21">
                                            <icon-phone/>
                                        </icon-base>
                                        <a :href="'tel:' + customer.phone_number">{{customer.phone_number}}</a></div>
                                </div>
                                <div class="col billing-col"><p>{{customer.billing_cc}}</p></div>
                                <div class="col creaded-col"><p class="title">Creaded:</p>
                                    <p class="creaded-col-date">{{getDate(customer.created_at)}}</p>
                                    <p class="creaded-col-time">{{getTime(customer.created_at)}}</p></div>
                                <div class="col btn-col">
                                    <a href="#" class="extend-btn light-green small-btn" data-title="Edit" @click.prevent="editCustomer(customer)">
                                        <icon-base  width="25" height="25" viewBox="0 0 25 25"><icon-pencil/></icon-base>
                                        <span>Edit</span>
                                    </a>
                                    <a href="#" class="delete-btn light-red small-btn" data-title="Delete" @click.prevent="delCustomer(customer.id)">
                                        <icon-base width="20" height="21" viewBox="0 0 20 21"><icon-delete color="#D82A1F"/></icon-base>
                                        <span>Delete</span>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!--<a href="#" class="js-show-more" @click.prevent="loadMore" >Show more</a>-->
                </div>

            </div>
        </main>
    </div>
</template>

<script>
import {mapActions, mapState, mapMutations} from "vuex"
import dateformat from "dateformat"
import IconBase from "../common/IconBase";
import IconPlus from "../common/icons/IconPlus";
import IconPencil from "../common/icons/IconPencil";
import IconDelete from "../common/icons/IconDelete";
import Confirm from "../common/Confirm"
import CustomerForm from "./Customers/CustomerForm"
import IconPhone from "../common/icons/IconPhone";
import IconMail from "../common/icons/IconMail";
import SimpleTableFilter from "../common/SimpleTableFilter";
import SortBox from "./SortBox";
import IconFilterMobile from "../common/icons/IconFilterMobile";
import CustomerFilterForm from "./Customers/CustomerFilterForm";

export default {
    name: 'customers',

    components: {
        IconFilterMobile,
        SortBox,
        SimpleTableFilter,
        IconMail,
        IconPhone,
        IconDelete,
        IconPencil,
        IconPlus,
        IconBase
    },

    computed: {
        ...mapState('customers', [
            'customers',
        ]),
    },

    data() {
        return {
            loading: false,
            filterParam: 'company',
            order: false,
            openSort: false,
            names : {
                'company' : 'Company',
                'contact_person' : 'Contact person',
                'email' : 'Email',
                'phone_number' : 'Phone number',
                'billing_cc': 'Billing cc',
                'created_at' : 'Created',
            }
    }
    },

    methods: {
        ...mapActions('customers', [
            'loadCustomers',
            'deleteCustomer',
            'addCustomer',
            'updateCustomer',
        ]),
        ...mapMutations([
            'switchPopup',
            'setPopupComponent',
            'setPopupData'
        ]),
        getDate(time) {
            return dateformat(time * 1000, "dd.mm.yy");
        },
        getTime(time) {
            return dateformat(time * 1000, "h:MM TT");
        },
        addNewCustomer() {
            this.setPopupComponent(CustomerForm);
            this.setPopupData({type: 'add', func: this.addCustomer });
            this.switchPopup(true);
        },
        editCustomer(customer) {
            this.setPopupComponent(CustomerForm);
            this.setPopupData({item: customer, type: 'edit', func: this.updateCustomer });
            this.switchPopup(true);
        },
        delCustomer(id) {
            this.setPopupComponent(Confirm);
            this.setPopupData({id: id, func: this.deleteCustomer });
            this.switchPopup(true);
        },
        mobileFilterClick() {
            this.setPopupComponent(CustomerFilterForm);
            this.switchPopup(true);
        },
        filterClick(value) {
            this.filterParam = value.name;
            this.order = value.order;
            this.openSort = false;

            let params = {sort: !this.order ? '-' + this.filterParam : this.filterParam};
            //params["UserSearch[status]"] = 10;
            if (value.search) {
                params["UserSearch[" + this.filterParam + "]"] = value.search;
            }

            if (this.filterParam) {
                this.loading = true;
                this.loadCustomers(params).then(() => {
                    this.loading = false;
                });
            }
        },
        loadMore() {
            this.loading = true;
            //let params = {};
            //params["UserSearch[status]"] = 10;
            this.loadCustomers().then(() => {
                this.loading = false;
            });
        }

    },

    mounted() {
        this.loading = true;
        let params = {};
        //params["UserSearch[status]"] = 10;
        this.loadCustomers(params).then(() => {
            this.loading = false;
        });

    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
